export const contextos = [
  {
    label: "Condicional",
    value: "condicional",
  },
  {
    label: "Orçamento",
    value: "orcamento",
  },
  {
    label: "Pedido",
    value: "pedido",
  },
  {
    label: "NF Saída",
    value: "nf-saida",
  },
  {
    label: "Orçamento (Serviço)",
    value: "orcamento-servico",
  },
  {
    label: "Ordem de Serviço",
    value: "ordem-servico",
  },
  {
    label: "Boleto",
    value: "boleto"
  },
];